import { SearchParams, SearchParamsConfig } from "../../../types/search-types";
import { Plugin } from "..";

class BuildingTypes implements Plugin {
  async exec(
    segment: string,
    searchParams: SearchParams,
    config: SearchParamsConfig
  ): Promise<SearchParams> {

    if (searchParams.buildingTypes) {
      return searchParams;
    }

    const buildingTypes: string[] = [];

    for (const [key, value] of config.buildingTypes.entries()) {
      if (segment.indexOf(key) >= 0) {
        buildingTypes.push(value);
      }
    }

    if (buildingTypes.length) {
      searchParams.buildingTypes = buildingTypes;
    }

    return searchParams;
  }
}

export const buildingTypes = new BuildingTypes();
